import Button from '@kiwicom/orbit-components/lib/Button';
import { Props as ButtonProps } from '@kiwicom/orbit-components/lib/Button/types.d';

import WrapWithLink from './WrapWithLink';

/**
 * Displays a single important or secondary action a user can take.
 * The action is implemented using a link.
 *
 * For usage, consult:
 * - Link props: https://nextjs.org/docs/api-reference/next/link
 * - Button props: https://orbit.kiwi/components/button/react/
 *
 * @returns a button element wrapped with Next.js's Link
 */
const LinkButton = WrapWithLink<ButtonProps & { ref?: null }>(Button);

export default LinkButton;
